import { render, staticRenderFns } from "./PriceChartEntry.vue?vue&type=template&id=31a39164&"
import script from "./PriceChartEntry.vue?vue&type=script&lang=js&"
export * from "./PriceChartEntry.vue?vue&type=script&lang=js&"
import style0 from "./PriceChartEntry.vue?vue&type=style&index=0&id=31a39164&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports